<!-- Canvas caché pour la génération d'image -->
<canvas #badgeCanvas></canvas>

<!-- Preview optionnel -->
<!-- @if (generatedImage) {
<div class="badge-preview">
    <img [src]="generatedImage" alt="Badge preview" />
</div>
} -->